import { withErrorBoundary } from "react-error-boundary";
import { withNavigationWatcher } from "./contexts/navigation";
import { ErrorComponentCallback } from "./components/error-callback";
import {
  WelcomePage,
  HomePage,
  TablePage,
  EmployeePage,
  ApprovalPage,
  LeavePage,
  OvertimePage,
  ElementsPage,
  PermissionsPage,
  ChangePasswordPage,
  DefaultPage,
  ErrorPage,
  TimeKeepingPage,
  TransactionPage,
  TimesheetPage,
  SettingPage,
} from "./pages";

const routes = [
  {
    pageId: "P0001",
    path: "/card",
    component: LeavePage.LeaveCard,
  },
  {
    pageId: "P0001",
    path: "/welcome",
    component: WelcomePage,
  },
  {
    pageId: "P0002",
    path: "/home",
    component: HomePage,
  },
  {
    pageId: "P0003",
    path: "/default/announcement/list",
    component: DefaultPage.AnnouncementPage,
  },
  {
    pageId: "P0049",
    path: "/default/announcement-user/list",
    component: DefaultPage.AnnouncementUserPage,
  },
  {
    pageId: "P0033",
    path: "/table",
    component: TablePage,
  },
  {
    pageId: "P0029",
    path: "/default/personal-information",
    component: EmployeePage,
  },
  {
    pageId: "P0010",
    path: "/default/dictionary/list",
    component: DefaultPage.DictionaryPage,
  },
  {
    pageId: "P0027",
    path: "/default/payslip/list",
    component: DefaultPage.PayslipPage,
    // component: Payslips,
  },
  {
    pageId: "P0033",
    path: "/default/scheduler-event/list",
    component: DefaultPage.SchedulerEventPage,
  },
  {
    pageId: "P0008",
    path: "/default/dashboard",
    component: DefaultPage.DashboardPage,
  },
  {
    pageId: "P0019",
    path: "/default/notification-configuration/list",
    component: DefaultPage.DashboardPage,
  },
  {
    pageId: "P0005",
    path: "/approval/approval-setting-department/list",
    component: ApprovalPage.ApprovalSettingDepartmentList,
  },
  {
    pageId: "P0006",
    path: "/approval/approval-setting-department/create",
    component: ApprovalPage.ApprovalSettingDepartmentCreate,
  },
  {
    pageId: "P0007",
    path: "/approval/approval-setting-department/:slug",
    component: ApprovalPage.ApprovalSettingDepartmentDetail,
  },
  {
    pageId: "P0011",
    path: "/approval/approval-setting-employee/list",
    component: ApprovalPage.ApprovalSettingEmployeeList,
  },
  {
    pageId: "P0043",
    path: "/approval/approval-setting-employee/create",
    component: ApprovalPage.ApprovalSettingCreateEmployee,
  },
  {
    pageId: "P0048",
    path: "/approval/approval-setting-employee/:slug",
    component: ApprovalPage.ApprovalSettingEmployeeDetail,
  },
  {
    pageId: "P0014",
    path: "/leave/leave-registration/list",
    component: LeavePage.LeaveRegistrationList,
  },
  {
    pageId: "P0018",
    path: "/leave/leave-summary/list",
    component: LeavePage.LeaveSummaryList,
  },
  {
    pageId: "P0017",
    path: "/leave/leave-registration-data/list",
    component: LeavePage.LeaveRegistrationDataList,
  },
  {
    pageId: "P0015",
    path: "/leave/leave-registration/create",
    component: LeavePage.LeaveRegistrationCreate,
  },
  {
    pageId: "P0016",
    path: "/leave/leave-registration/:slug",
    component: LeavePage.LeaveRegistrationDetail,
  },
  {
    pageId: "P0013",
    path: "/leave/leave-approval/list",
    component: LeavePage.LeaveApproval,
  },
  {
    pageId: "P0022",
    path: "/overtime/overtime-registration/list",
    component: OvertimePage.OvertimeRegistrationList,
  },
  {
    pageId: "P0026",
    path: "/overtime/overtime-summary/list",
    component: OvertimePage.OvertimeSummaryList,
  },
  {
    pageId: "P0023",
    path: "/overtime/overtime-registration/create",
    component: OvertimePage.OvertimeRegistrationCreate,
  },

  {
    pageId: "P0024",
    path: "/overtime/overtime-registration/:slug",
    component: OvertimePage.OvertimeRegistrationDetail,
  },
  {
    pageId: "P0025",
    path: "/overtime/overtime-registration-data/list",
    component: OvertimePage.OvertimeRegistrationDataList,
  },
  {
    pageId: "P0021",
    path: "/overtime/overtime-approval/list",
    component: OvertimePage.OvertimeApprovalList,
  },
  {
    pageId: "P0035",
    path: "/timekeeping/timekeeping-online/list",
    component: TimeKeepingPage.TimeKeepingOnlineList,
  },
  {
    pageId: "P0036",
    path: "/timekeeping/timekeeping-online-approval/list",
    component: TimeKeepingPage.TimeKeepingOnlineApprovalList,
  },
  {
    pageId: "P0037",
    path: "/timekeeping/timekeeping-online-data/list",
    component: TimeKeepingPage.TimeKeepingOnlineDataList,
  },
  {
    pageId: "P0044",
    path: "/transactions/transactions-adjustment/list",
    component: TransactionPage.TransactionAdjustmentList,
  },
  {
    pageId: "P0045",
    path: "/transactions/transactions-adjustment-approval/list",
    component: TransactionPage.TransactionAdjustmentApprovalList,
  },
  {
    pageId: "P0046",
    path: "/transactions/transactions-adjustment-data/list",
    component: TransactionPage.TransactionAdjustmentDataList,
  },
  {
    pageId: "P0039",
    path: "/timesheet/timesheet-approval/list",
    component: TimesheetPage.TimesheetApprovalList,
  },
  {
    pageId: "P0040",
    path: "/timesheet/timesheet-information/list",
    component: TimesheetPage.TimesheetApprovalList,
  },
  {
    pageId: "P0038",
    path: "/timesheet/timesheet/list",
    component: TimesheetPage.TimesheetList,
  },
  {
    pageId: "P0041",
    path: "/timesheet/timesheet-manager/list",
    component: TimesheetPage.TimesheetManagerList,
  },
  {
    pageId: "P0042",
    path: "/timesheet/timesheet-summary-data/list",
    component: TimesheetPage.TimesheetSummaryDataList,
  },
  {
    pageId: "Page0011",
    path: "/elements",
    component: ElementsPage,
  },

  {
    pageId: "P0048",
    path: "/not-found",
    component: ErrorPage.NotFoundPage,
  },

  {
    pageId: "Page0017",
    path: "/403",
    component: ErrorPage.UnAuthorizedPage,
  },
  {
    pageId: "Page0017",
    path: "/progress-request/:token",
    component: ErrorPage.ApprovePage,
  },
  {
    pageId: "P0047",
    path: "/change-password",
    component: ChangePasswordPage,
  },

  // Permission Zone
  {
    pageId: "P0032",
    path: "/permissions/roles/list",
    component: PermissionsPage.RoleListPage,
  },
  {
    pageId: "P0030",
    path: "/permissions/role-details/:slug",
    component: PermissionsPage.RoleDetailPage,
  },
  {
    pageId: "P0031",
    path: "/permissions/role-users/list",
    component: PermissionsPage.RoleUserPage,
  },
  {
    pageId: "P0047",
    path: "/permissions/users/list",
    component: PermissionsPage.UsersPage,
  },


  // Setting Zone
  {
    pageId: "P0051",
    path: "/setting/enum-setting/list",
    component: SettingPage.EnumSettingPage,
  },
  {
    pageId: "P0052",
    path: "/setting/screen-setting/list",
    component: SettingPage.ScreenSettingPage,
  },
  {
    pageId: "P0053",
    path: "/setting/lookup-setting/list",
    component: SettingPage.LookupSettingPage,
  },
  {
    pageId: "P0054",
    path: "/setting/common-setting/list",
    component: SettingPage.CommonSettingPage,
  },
  {
    pageId: "P0055",
    path: "/setting/navigation-setting/list",
    component: SettingPage.NavigationSettingPage,
  },
  {
    pageId: "P0056",
    path: "/setting/email-setting/list",
    component: SettingPage.EmailSettingPage,
  },
  {
    pageId: "P0057",
    path: "/setting/home-setting/list",
    component: SettingPage.HomeSettingPage,
  },
  {
    pageId: "P0058",
    path: "/setting/dictionary-setting/list",
    component: SettingPage.DictionaryPage,
  },
];

export default routes.map((route) => {
  return {
    ...route,
    component: withErrorBoundary(withNavigationWatcher(route.component), {
      FallbackComponent: ErrorComponentCallback,
    }),
  };
});
